import React from 'react';
import './Hero.css';

function Hero({ language }) {
  return (
    <section className="hero" id="home">
      <div className="container">
        <h1>Find Your Dream Property with Maggie !</h1>
        <p>With over 15 years of experience in real estate, I provide personalized service to help you buy, sell, or invest in properties that match your vision and goals.</p>
        <a href="#contact" className="btn">Schedule a Consultation</a>
      </div>
    </section>
  );
}

export default Hero;
